import { createRouter, createWebHistory } from 'vue-router'
import { ElMessageBox } from 'element-plus'
import store from '@/store'
import IndexView from '../views/IndexView.vue'
import LoginView from '../views/LoginView.vue'
import ReportFormView from '../views/ReportFormView.vue'

const routes = [
  {
    path: '/index',
    name: 'index',
    component: IndexView,
  },
  {
    path: '/leads_user_list',
    name: 'leads_user_list',
    component: () =>
      import(
        /* webpackChunkName: "leads_user_list" */ '../views/LeadsUserListView.vue'
      ),
  },
  {
    path: '/enterprise_leads_user_list',
    name: 'enterprise_leads_user_list',
    component: () =>
      import(
        /* webpackChunkName: "enterprise_leads_user_list" */ '../views/EnterpriseLeadsUserListView.vue'
      ),
  },
  {
    path: '/leads_action_user_list',
    name: 'leads_action_user_list',
    component: () =>
      import(
        /* webpackChunkName: "leads_action_user_list" */ '../views/LeadsActionUserListView.vue'
      ),
  },
  {
    path: '/enterprise_video_comment',
    name: 'enterprise_video_comment',
    component: () =>
      import(
        /* webpackChunkName: "enterprise_video_comment" */ '../views/EnterpriseVideoCommentView.vue'
      ),
  },
  {
    path: '/comment_manage',
    name: 'comment_manage',
    component: () =>
      import(
        /* webpackChunkName: "comment_manage" */ '../views/CommentManageView.vue'
      ),
  },
  {
    path: '/reply',
    name: 'reply',
    component: () =>
      import(/* webpackChunkName: "reply" */ '../views/ReplyView.vue'),
  },
  {
    path: '/message_send',
    name: 'message_send',
    component: () =>
      import(
        /* webpackChunkName: "message_send" */ '../views/MessageSendView.vue'
      ),
  },
  {
    path: '/enter_im',
    name: 'enter_im',
    component: () =>
      import(/* webpackChunkName: "enter_im" */ '../views/EnterImView.vue'),
  },
  {
    path: '/rank',
    name: 'rank',
    component: () =>
      import(/* webpackChunkName: "rank" */ '../views/RankView.vue'),
  },
  {
    path: '/business_ad',
    name: 'business_ad',
    component: () =>
      import(
        /* webpackChunkName: "business_ad" */ '../views/BusinessAdView.vue'
      ),
  },
  {
    path: '/business_ad_bgbconsume',
    name: 'business_ad_bgbconsume',
    component: () =>
      import(
        /* webpackChunkName: "business_ad_bgbconsume" */ '../views/BusinessAdBgbconsumeView.vue'
      ),
  },
  {
    path: '/business_ad_bgbtime',
    name: 'business_ad_bgbtime',
    component: () =>
      import(
        /* webpackChunkName: "business_ad_bgbtime" */ '../views/BusinessAdBgbtimeView.vue'
      ),
  },
  {
    path: '/business_ad_bgbreclist',
    name: 'business_ad_bgbreclist',
    component: () =>
      import(
        /* webpackChunkName: "business_ad_bgbreclist" */ '../views/BusinessAdBgbreclistView.vue'
      ),
  },
  {
    path: '/course',
    name: 'course',
    component: () =>
      import(/* webpackChunkName: "course" */ '../views/CourseView.vue'),
  },
  {
    path: '/system_setting_topic',
    name: 'system_setting_topic',
    component: () =>
      import(
        /* webpackChunkName: "system_setting_topic" */ '../views/SystemSettingTopicView.vue'
      ),
  },
  {
    path: '/system_setting_cluewords',
    name: 'system_setting_cluewords',
    component: () =>
      import(
        /* webpackChunkName: "system_setting_cluewords" */ '../views/SystemSettingCluewordsView.vue'
      ),
  },
  {
    path: '/system_setting_user',
    name: 'system_setting_user',
    component: () =>
      import(
        /* webpackChunkName: "system_setting_user" */ '../views/SystemSettingUserView.vue'
      ),
  },
  {
    path: '/auth',
    name: 'auth',
    component: () =>
      import(/* webpackChunkName: "auth" */ '../views/AuthView.vue'),
  },
  {
    path: '/operation_data',
    name: 'operation_data',
    component: () =>
      import(
        /* webpackChunkName: "operation_data" */ '../views/OperationDataView.vue'
      ),
  },
  {
    path: '/business_ad_dingxiang',
    name: 'business_ad_dingxiang',
    component: () =>
      import(
        /* webpackChunkName: "business_ad_dingxiang" */ '../views/BusinessAdDingxiangView.vue'
      ),
  },
  {
    path: '/empty',
    name: 'empty',
    component: () =>
      import(/* webpackChunkName: "empty" */ '../views/EmptyView.vue'),
  },
  {
    path: '/data_center_account',
    name: 'data_center_account',
    component: () =>
      import(
        /* webpackChunkName: "data_center_account" */ '../views/DataCenterAccountView.vue'
      ),
  },
  {
    path: '/video',
    name: 'video',
    component: () =>
      import(/* webpackChunkName: "video" */ '../views/VideoView.vue'),
  },
  {
    path: '/video_release_video_manage:rid?',
    name: 'video_release_video_manage',
    component: () =>
      import(
        /* webpackChunkName: "video_release_video_manage" */ '../views/VideoReleaseVideoManageView.vue'
      ),
  },
  {
    path: '/video_release_manage',
    name: 'video_release_manage',
    component: () =>
      import(
        /* webpackChunkName: "video_release_manage" */ '../views/VideoReleaseManageView.vue'
      ),
  },
  {
    path: '/video_task',
    name: 'video_task',
    component: () =>
      import(/* webpackChunkName: "video_task" */ '../views/VideoTaskView.vue'),
  },
  {
    path: '/video_release',
    name: 'video_release',
    component: () =>
      import(
        /* webpackChunkName: "video_release" */ '../views/VideoReleaseView.vue'
      ),
  },
  {
    path: '/video_pro',
    name: 'video_pro',
    component: () =>
      import(/* webpackChunkName: "video_pro" */ '../views/VideoProView.vue'),
  },
  {
    path: '/video_pro_create/:id?',
    name: 'video_pro_create',
    component: () =>
      import(
        /* webpackChunkName: "video_pro_create" */ '../views/VideoProCreateView.vue'
      ),
  },
  {
    path: '/video_pro_task',
    name: 'video_pro_task',
    component: () =>
      import(
        /* webpackChunkName: "video_pro_task" */ '../views/VideoProTaskView.vue'
      ),
  },
  {
    path: '/video_pro_material',
    name: 'video_pro_material',
    component: () =>
      import(
        /* webpackChunkName: "video_pro_material" */ '../views/VideoProMaterialView.vue'
      ),
  },
  {
    path: '/video_pro_material_class',
    name: 'video_pro_material_class',
    component: () =>
      import(
        /* webpackChunkName: "video_pro_material_class" */ '../views/VideoProMaterialClassView.vue'
      ),
  },
  {
    path: '/video_pro_release_task',
    name: 'video_pro_release_task',
    component: () =>
      import(
        /* webpackChunkName: "video_pro_release_task" */ '../views/VideoProReleaseTaskView.vue'
      ),
  },
  {
    path: '/video_pro_release_detailed/:rid?',
    name: 'video_pro_release_detailed',
    component: () =>
      import(
        /* webpackChunkName: "video_pro_release_detailed" */ '../views/VideoProReleaseDetailedView.vue'
      ),
  },
  {
    path: '/video_pro_release_schema/:id?',
    name: 'video_pro_release_schema',
    component: () =>
      import(
        /* webpackChunkName: "video_pro_release_schema" */ '../views/VideoProReleaseSchemaView.vue'
      ),
  },
  {
    path: '/video_pro_release_manual/:id?',
    name: 'video_pro_release_manual',
    component: () =>
      import(
        /* webpackChunkName: "video_pro_release_manual" */ '../views/VideoProReleaseManualView.vue'
      ),
  },
  {
    path: '/video_pro_release_smart/:id?',
    name: 'video_pro_release_smart',
    component: () =>
      import(
        /* webpackChunkName: "video_pro_release_smart" */ '../views/VideoProReleaseSmartView.vue'
      ),
  },
  {
    path: '/smart_customer_acquisition',
    name: 'smart_customer_acquisition',
    component: () =>
      import(
        /* webpackChunkName: "smart_customer_acquisition" */ '../views/SmartCustomerAcquisitionView.vue'
      ),
  },
  {
    path: '/task_sokey',
    name: 'task_sokey',
    component: () =>
      import(/* webpackChunkName: "task_sokey" */ '../views/TaskSokeyView.vue'),
  },
  {
    path: '/task_crm',
    name: 'task_crm',
    component: () =>
      import(/* webpackChunkName: "task_crm" */ '../views/TaskCrmView.vue'),
  },
  {
    path: '/task_plcrm',
    name: 'task_plcrm',
    component: () =>
      import(/* webpackChunkName: "task_plcrm" */ '../views/TaskPlcrmView.vue'),
  },
  {
    path: '/task_adv_finance',
    name: 'task_adv_finance',
    component: () =>
      import(
        /* webpackChunkName: "task_adv_finance" */ '../views/TaskAdvFinanceView.vue'
      ),
  },
  {
    path: '/task_qcy_finance',
    name: 'task_qcy_finance',
    component: () =>
      import(
        /* webpackChunkName: "task_qcy_finance" */ '../views/TaskQcyFinanceView.vue'
      ),
  },
  {
    path: '/site',
    name: 'site',
    component: () =>
      import(/* webpackChunkName: "site" */ '../views/SiteView.vue'),
  },
  {
    path: '/task_crm_index',
    name: 'task_crm_index',
    component: () =>
      import(
        /* webpackChunkName: "task_crm_index" */ '../views/TaskCrmIndexView.vue'
      ),
  },
  {
    path: '/business_ad_crm',
    name: 'business_ad_crm',
    component: () =>
      import(
        /* webpackChunkName: "business_ad_crm" */ '../views/BusinessAdCrmView.vue'
      ),
  },
  {
    path: '/message_push',
    name: 'message_push',
    component: () =>
      import(
        /* webpackChunkName: "message_push" */ '../views/MessagePushView.vue'
      ),
  },
  {
    path: '/business_ad_plan',
    name: 'business_ad_plan',
    component: () =>
      import(
        /* webpackChunkName: "business_ad_plan" */ '../views/BusinessAdPlanView.vue'
      ),
  },
  {
    path: '/task_plan',
    name: 'task_plan',
    component: () =>
      import(/* webpackChunkName: "task_plan" */ '../views/TaskPlanView.vue'),
  },
  {
    path: '/yjsc_add/:id?',
    name: 'yjsc_add',
    component: () =>
      import(/* webpackChunkName: "yjsc_add" */ '../views/YjscAddView.vue'),
  },
  {
    path: '/yjsc_list',
    name: 'yjsc_list',
    component: () =>
      import(/* webpackChunkName: "yjsc_list" */ '../views/YjscListView.vue'),
  },
  {
    path: '/video_bp_task_create/:id?',
    name: 'video_bp_task_create',
    component: () =>
      import(
        /* webpackChunkName: "video_bp_task_create" */ '../views/VideoBpTaskCreateView.vue'
      ),
  },
  {
    path: '/video_bp_task',
    name: 'video_bp_task',
    component: () =>
      import(
        /* webpackChunkName: "video_bp_task" */ '../views/VideoBpTaskView.vue'
      ),
  },
  {
    path: '/video_pro_nav',
    name: 'video_pro_nav',
    component: () =>
      import(
        /* webpackChunkName: "video_pro_nav" */ '../views/VideoProNavView.vue'
      ),
  },
  {
    path: '/video_batch_task_template',
    name: 'video_batch_task_template',
    component: () =>
      import(
        /* webpackChunkName: "video_batch_task_template" */ '../views/VideoBatchTaskTemplateView.vue'
      ),
  },
  {
    path: '/video_batch_task_create/:id?',
    name: 'video_batch_task_create',
    component: () =>
      import(
        /* webpackChunkName: "video_batch_task_create" */ '../views/VideoBatchTaskCreateView.vue'
      ),
  },
  {
    path: '/video_batch_task',
    name: 'video_batch_task',
    component: () =>
      import(
        /* webpackChunkName: "video_batch_task" */ '../views/VideoBatchTaskView.vue'
      ),
  },
  {
    path: '/business_ad_plcrm',
    name: 'business_ad_plcrm',
    component: () =>
      import(
        /* webpackChunkName: "business_ad_plcrm" */ '../views/BusinessAdPlcrmView.vue'
      ),
  },
  {
    path: '/accurate_setting',
    name: 'accurate_setting',
    component: () =>
      import(
        /* webpackChunkName: "accurate_setting" */ '../views/AccurateSettingView.vue'
      ),
  },
  {
    path: '/accurate_keywords',
    name: 'accurate_keywords',
    component: () =>
      import(
        /* webpackChunkName: "accurate_keywords" */ '../views/AccurateKeywordsView.vue'
      ),
  },
  {
    path: '/accurate_data',
    name: 'accurate_data',
    component: () =>
      import(
        /* webpackChunkName: "accurate_data" */ '../views/AccurateDataView.vue'
      ),
  },
  {
    path: '/accurate_finance',
    name: 'accurate_finance',
    component: () =>
      import(
        /* webpackChunkName: "accurate_finance" */ '../views/AccurateFinanceView.vue'
      ),
  },
  {
    path: '/user_intention',
    name: 'user_intention',
    component: () =>
      import(
        /* webpackChunkName: "user_intention" */ '../views/UserIntentionView.vue'
      ),
  },
  {
    path: '/user_intention_card',
    name: 'user_intention_card',
    component: () =>
      import(
        /* webpackChunkName: "user_intention_card" */ '../views/UserIntentionCardView.vue'
      ),
  },
  {
    path: '/user_intention_reply',
    name: 'user_intention_reply',
    component: () =>
      import(
        /* webpackChunkName: "user_intention_reply" */ '../views/UserIntentionReplyView.vue'
      ),
  },
  {
    path: '/user_intention_dialogu/:aid?/:open_id?',
    name: 'user_intention_dialogu',
    component: () =>
      import(
        /* webpackChunkName: "user_intention_dialogu" */ '../views/UserIntentionDialoguView.vue'
      ),
  },
  {
    path: '/video_item_comment',
    name: 'video_item_comment',
    component: () =>
      import(
        /* webpackChunkName: "video_item_comment" */ '../views/VideoItemCommentView.vue'
      ),
  },
  {
    path: '/mix',
    name: 'mix',
    component: () =>
      import(/* webpackChunkName: "mix" */ '../views/MixView.vue'),
  },
  {
    path: '/douyin_rank_task_keyword',
    name: 'douyin_rank_task_keyword',
    component: () =>
      import(
        /* webpackChunkName: "douyin_rank_task_keyword" */ '../views/DouyinRankTaskKeywordView.vue'
      ),
  },
  {
    path: '/douyin_rank_task_finance',
    name: 'douyin_rank_task_finance',
    component: () =>
      import(
        /* webpackChunkName: "douyin_rank_task_finance" */ '../views/DouyinRankTaskFinanceView.vue'
      ),
  },
  {
    path: '/douyin_rank_task_data',
    name: 'douyin_rank_task_data',
    component: () =>
      import(
        /* webpackChunkName: "douyin_rank_task_data" */ '../views/DouyinRankTaskDataView.vue'
      ),
  },
  {
    path: '/video_new_release_task',
    name: 'video_new_release_task',
    component: () =>
      import(
        /* webpackChunkName: "video_new_release_task" */ '../views/VideoNewReleaseTaskView.vue'
      ),
  },
  {
    path: '/video_new_release_manual/:id?',
    name: 'video_new_release_manual',
    component: () =>
      import(
        /* webpackChunkName: "video_new_release_manual" */ '../views/VideoNewReleaseManualView.vue'
      ),
  },
  {
    path: '/video_new_release_smart/:id?',
    name: 'video_new_release_smart',
    component: () =>
      import(
        /* webpackChunkName: "video_new_release_smart" */ '../views/VideoNewReleaseSmartView.vue'
      ),
  },
  {
    path: '/video_new_release_detailed/:rid?/:pid?',
    name: 'video_new_release_detailed',
    component: () =>
      import(
        /* webpackChunkName: "video_new_release_detailed" */ '../views/VideoNewReleaseDetailedView.vue'
      ),
  },
  {
    path: '/material',
    name: 'material',
    component: () =>
      import(/* webpackChunkName: "material" */ '../views/MaterialView.vue'),
  },
  {
    path: '/material_class',
    name: 'material_class',
    component: () =>
      import(
        /* webpackChunkName: "material_class" */ '../views/MaterialClassView.vue'
      ),
  },
  {
    path: '/video_ai_task',
    name: 'video_ai_task',
    component: () =>
      import(
        /* webpackChunkName: "video_ai_task" */ '../views/VideoAiTaskView.vue'
      ),
  },
  {
    path: '/video_ai_task_editor/:id',
    name: 'video_ai_task_editor',
    component: () =>
      import(
        /* webpackChunkName: "video_ai_task_editor" */ '../views/VideoAiTaskEditorView.vue'
      ),
  },
  {
    path: '/mount',
    name: 'mount',
    component: () =>
      import(/* webpackChunkName: "mount" */ '../views/MountView.vue'),
  },
  {
    path: '/operate',
    name: 'operate',
    component: () =>
      import(/* webpackChunkName: "operate" */ '../views/OperateView.vue'),
  },
  {
    path: '/guide',
    name: 'guide',
    component: () =>
      import(/* webpackChunkName: "guide" */ '../views/GuideView.vue'),
  },
  {
    path: '/writing',
    name: 'writing',
    component: () =>
      import(/* webpackChunkName: "writing" */ '../views/WritingView.vue'),
  },
  {
    path: '/image_text_task_editor/:id?',
    name: 'image_text_task_editor',
    component: () =>
      import(
        /* webpackChunkName: "image_text_task_editor" */ '../views/ImageTextTaskEditorView.vue'
      ),
  },
  {
    path: '/image_text_task_manage',
    name: 'image_text_task_manage',
    component: () =>
      import(
        /* webpackChunkName: "image_text_task_manage" */ '../views/ImageTextTaskManageView.vue'
      ),
  },
  {
    path: '/user_list',
    name: 'user_list',
    component: () =>
      import(/* webpackChunkName: "user_list" */ '../views/UserListView.vue'),
  },
  {
    path: '/tool',
    name: 'tool',
    component: () =>
      import(/* webpackChunkName: "tool" */ '../views/ToolView.vue'),
  },
  {
    path: '/tool_image_template',
    name: 'tool_image_template',
    component: () =>
      import(
        /* webpackChunkName: "tool_image_template" */ '../views/ToolImageTemplateView.vue'
      ),
  },
  {
    path: '/hot_video',
    name: 'hot_video',
    component: () =>
      import(/* webpackChunkName: "hot_video" */ '../views/HotVideoView.vue'),
  },
  // {
  //   path: '/contactcard',
  //   name: 'contactcard',
  //   component: () =>
  //     import(
  //       /* webpackChunkName: "contactcard" */ '../views/ContactcardView.vue'
  //     ),
  // },
  {
    path: '/message_push_wx',
    name: 'message_push_wx',
    component: () =>
      import(
        /* webpackChunkName: "message_push_wx" */ '../views/MessagePushWxView.vue'
      ),
  },
  {
    path: '/v3_video_release',
    name: 'v3_video_release',
    component: () =>
      import(
        /* webpackChunkName: "v3_video_release" */ '../views/V3VideoReleaseView.vue'
      ),
  },
  {
    path: '/v3_video_release_editor/:id?',
    name: 'v3_video_release_editor',
    component: () =>
      import(
        /* webpackChunkName: "v3_video_release_editor" */ '../views/V3VideoReleaseEditorView.vue'
      ),
  },
  {
    path: '/v3_video_single_release',
    name: 'v3_video_single_release',
    component: () =>
      import(
        /* webpackChunkName: "v3_video_single_release" */ '../views/V3VideoSingleReleaseView.vue'
      ),
  },
  {
    path: '/v3_video_single_release_editor/:id?',
    name: 'v3_video_single_release_editor',
    component: () =>
      import(
        /* webpackChunkName: "v3_video_single_release_editor" */ '../views/V3VideoSingleReleaseEditorView.vue'
      ),
  },
  {
    path: '/v3_video_single_release_batch_create',
    name: 'v3_video_single_release_batch_create',
    component: () =>
      import(
        /* webpackChunkName: "v3_video_single_release_batch_create" */ '../views/V3VideoSingleReleaseBatchCreateView.vue'
      ),
  },

  {
    path: '/v2_image_text_template_class',
    name: 'v2_image_text_template_class',
    component: () =>
      import(
        /* webpackChunkName: "v2_image_text_template_class" */ '../views/V2ImageTextTemplateClassView.vue'
      ),
  },
  {
    path: '/v2_image_text_template/:cid?',
    name: 'v2_image_text_template',
    component: () =>
      import(
        /* webpackChunkName: "v2_image_text_template" */ '../views/V2ImageTextTemplateView.vue'
      ),
  },
  {
    path: '/v2_image_text_task_manage',
    name: 'v2_image_text_task_manage',
    component: () =>
      import(
        /* webpackChunkName: "v2_image_text_task_manage" */ '../views/V2ImageTextTaskManageView.vue'
      ),
  },
  {
    path: '/v2_image_text_task_editor/:id?',
    name: 'v2_image_text_task_editor',
    component: () =>
      import(
        /* webpackChunkName: "v2_image_text_task_editor" */ '../views/V2ImageTextTaskEditorView.vue'
      ),
  },
  {
    path: '/material_recycle/:id?',
    name: 'material_recycle',
    component: () =>
      import(
        /* webpackChunkName: "material_recycle" */ '../views/MaterialRecycleView.vue'
      ),
  },
  {
    path: '/keywords',
    name: 'keywords',
    component: () =>
      import(/* webpackChunkName: "keywords" */ '../views/KeywordsView.vue'),
  },
  {
    path: '/report_forms',
    name: 'report_forms',
    component: () =>
      import(
        /* webpackChunkName: "report_forms" */ '../views/ReportFormsView.vue'
      ),
  },
  {
    path: '/douyin_data',
    name: 'douyin_data',
    component: () =>
      import(/* webpackChunkName: "douyin_data" */ '../views/DouyinData.vue'),
  },
  {
    path: '/copywriting_class',
    name: 'copywriting_class',
    component: () =>
      import(
        /* webpackChunkName: "copywriting_class" */ '../views/CopywritingClassView.vue'
      ),
  },
  {
    path: '/copywriting/:cid?',
    name: 'copywriting',
    component: () =>
      import(
        /* webpackChunkName: "copywriting" */ '../views/CopywritingView.vue'
      ),
  },
  {
    path: '/seven_seconds_list',
    name: 'seven_seconds_list',
    component: () =>
      import(
        /* webpackChunkName: "seven_seconds_list" */ '../views/SevenSecondsListView.vue'
      ),
  },
  {
    path: '/seven_seconds_task/:id?',
    name: 'seven_seconds_task',
    component: () =>
      import(
        /* webpackChunkName: "seven_seconds_task" */ '../views/SevenSecondsTaskView.vue'
      ),
  },
  {
    path: '/tandianma_task',
    name: 'tandianma_task',
    component: () =>
      import(
        /* webpackChunkName: "tandianma_task" */ '../views/TandianmaTaskView.vue'
      ),
  },
  {
    path: '/tandianma_task_create',
    name: 'tandianma_task_create',
    component: () =>
      import(
        /* webpackChunkName: "tandianma_task_create" */ '../views/TandianmaTaskCreateView.vue'
      ),
  },
  {
    path: '/privatemessage_manage',
    name: 'privatemessage_manage',
    component: () =>
      import(
        /* webpackChunkName: "privatemessage_manage" */ '../views/PrivatemessageManageView.vue'
      ),
  },
  {
    path: '/comment_data',
    name: 'comment_data',
    component: () =>
      import(
        /* webpackChunkName: "comment_data" */ '../views/CommentDataView.vue'
      ),
  },
  {
    path: '/bjh_auth',
    name: 'bjh_auth',
    component: () =>
      import(/* webpackChunkName: "bjh_auth" */ '../views/BjhAuthView.vue'),
  },
  {
    path: '/article_task',
    name: 'article_task',
    component: () =>
      import(
        /* webpackChunkName: "article_task" */ '../views/ArticleTaskView.vue'
      ),
  },
  {
    path: '/article_task_editor/:id?',
    name: 'article_task_editor',
    component: () =>
      import(
        /* webpackChunkName: "article_task_editor" */ '../views/ArticleTaskEditorView.vue'
      ),
  },
  {
    path: '/bzasone_rank',
    name: 'bzasone_rank',
    component: () =>
      import(
        /* webpackChunkName: "bzasone_rank" */ '../views/BzasoneRankView.vue'
      ),
  },
  {
    path: '/account_limit',
    name: 'account_limit',
    component: () =>
      import(
        /* webpackChunkName: "account_limit" */ '../views/AccountLimitView.vue'
      ),
  },
  {
    path: '/article_limit',
    name: 'article_limit',
    component: () =>
      import(
        /* webpackChunkName: "article_limit" */ '../views/ArticleLimitView.vue'
      ),
  },

  {
    path: '/report_form/:id/:code',
    name: 'report_form',
    component: ReportFormView,
    meta: { requiresAuth: false },
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'login',
    component: LoginView,
    meta: { requiresAuth: false },
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

// eslint-disable-next-line
router.beforeEach(async (to, from) => {
  if (to.name.indexOf('video_pro') !== -1) {
    // ElMessageBox.alert('功能正在开发中敬请期待！')
  }
  if (to.meta.requiresAuth !== false && store.state.userInfo === null) {
    return await store
      .dispatch('userInfo', { config: { routerBefore: true } })
      .catch((e) => {
        return {
          path: '/login',
          query: { redirect: to.fullPath },
        }
      })
  }
})

export default router
